import {TagCreateDto, TagDto, TagUpdateDto} from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";


export default function TagModalForm(props: TagModalProps) {

    const formItems: CrudFormItemProps[] = [
        {
            label: "Nazwa",
            name: nameof<TagCreateDto>("value"),
            rules: [
                {required: true, message: 'This field is required'}
            ]
        },
    ];

    return <CrudFormModal
        formItems={formItems}
        onSubmit={props.onSubmit}
        forceRender={true}
        destroyOnClose={true}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalCancelText={props.cancelButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
    />;
}

interface TagModalProps {
    initialValues?: TagCreateDto | TagUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: TagCreateDto | TagUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
    cancelButtonTitle: string;
}
